function appURL() {
  return process.env.REACT_APP_API_URL
}

const BaseURL = { appURL }

export default BaseURL
